// @flow
import { Field } from 'formik'
import * as React from 'react'
import ErrorLabel from 'ui/atoms/ErrorLabel'
import SelectField, {
  type Props as SelectFieldProps,
} from 'ui/molecules/SelectField'

type Props = {
  ...SelectFieldProps,
  name: string,
}

function FormikSelectField({ name, ...rest }: Props): React.Node {
  return (
    <Field name={name}>
      {({ field, meta }) => (
        <div>
          <SelectField
            {...rest}
            name={field.name}
            onBlur={field.onBlur}
            onChange={field.onChange}
            value={field.value}
          />
          {meta.touched && meta.error && <ErrorLabel>{meta.error}</ErrorLabel>}
        </div>
      )}
    </Field>
  )
}

export default FormikSelectField
